import { createContext } from "react";

const ContactsContext = createContext(null);
export default ContactsContext;